﻿$.fn.dxCtrlSuiviTraitementEmailServeurEnvoi = function custom_dxCtrlSuiviTraitementEmailServeurEnvoi(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlsuivitraitementemailserveurenvoi dx-ctrl");
        this.createInstance(new cdxCtrlSuiviTraitementEmailServeurEnvoi(this, option));
    }
    return this;
}

window.cdxCtrlSuiviTraitementEmailServeurEnvoi = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var progressBar = null
    var $TdStatut = null
    var $DivDetailStatut = null
    function mConstruit() {
        container.css("height", ((container.innerHeight() > 0) ? container.innerHeight() + "px" : ""))
        container.empty()
        container.css("padding", "0 5px")
        container.addClass("state-hover")
        container.on("click", function () {
            var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                target: container,
                showCloseButton: false,
                position: "right",
                contentTemplate: function (contentElement) {
                    contentElement.css("padding", "25px")
                    $("<div/>").appendTo(contentElement).dxCtrlButton({
                        width: "100%",
                        text: ((option.data.pause_envoi == "1") ? "Redémarrer" : "Mettre en pause"),
                        txtTooltip: ((option.data.pause_envoi == "1") ? "Arrêter la pause<br/>et redémarrer les envois" : "Mettre en pause les envois"),
                        onClick: function (e) {
                            if (option.data.pause_envoi == "1") { option.data.pause_envoi = "0" }
                            else { option.data.pause_envoi = "1" }
                            option.bddCtrl.getObjet(option.data).mSaveChamp("pause_envoi")
                            tt.hide()
                        }
                    }).dxCtrlButton("instance");
                    $("<div style='padding-top:5px;'/>").appendTo(contentElement).dxCtrlButton({
                        width: "100%",
                        text: "Annuler",
                        txtTooltip: "Annuler tous les destinataires<br/>qui n'ont pas été encore envoyé<br/>et finaliser l'envoi",
                        onClick: function (e) {
                            option.bddCtrl.mAjaxCall({
                                command: "annulerenvoicomemailsmsenvoi",
                                id_table_com: option.bddCtrl.getObjet(option.data).mGetTable().id_table,
                                id_com: option.bddCtrl.getObjet(option.data).cle()
                            }, function () {
                                mNotify("Vous avez annulé l'envoi de votre message. Celui-ci va rapidement s'arrêter.", "success", 6000)
                            })
                            tt.hide()
                        }
                    }).dxCtrlButton("instance");
                    $("<div style='padding-top:5px;'/>").appendTo(contentElement).dxCtrlButton({
                        width: "100%",
                        text: "Supprimer",
                        txtTooltip: "Supprimer le message<br/>(Cela arrêtera les envois)",
                        onClick: function (e) {
                            option.bddCtrl.getObjet(option.data).mDelData(function (data) {
                                mNotify("Vous avez supprimé votre message. L'envoi de celui-ci va rapidement s'arrêter.", "success", 6000)
                            })
                            tt.hide()
                        }
                    }).dxCtrlButton("instance");
                    $("<div style='padding-top:5px;'/>").appendTo(contentElement).dxCtrlButton({
                        width: "100%",
                        text: "Ouvrir",
                        txtTooltip: "Ouvrir le message",
                        onClick: function (e) {
                            page.mAddPopup(option.data)
                            tt.hide()
                        }
                    }).dxCtrlButton("instance");
                }
            }).dxCtrlTooltip("instance");
            tt.show();
        })
        var title = null
        switch (option.bddCtrl.getObjet(option.data).mGetTable().nom) {
            case "com_email_envoi":
                title = ((option.data.objet == null || option.data.objet.length == 0) ? "(aucun objet)" : option.data.objet)
                break;
            case "com_sms_envoi":
                title = ((option.data.body_txt == null || option.data.body_txt.length == 0) ? "(aucun texte)" : option.data.body_txt)
                break;
        }
        $("<div style='white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-style:italic;'><i>" + title + "</i></div>").appendTo(container)
        $DivDetailStatut = $("<div style='white-space:nowrap;overflow:hidden;text-overflow:ellipsis;'></div>").appendTo(container)
        var $Table = $("<table style='width:100%'/>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
        progressBar = $("<div/>").appendTo($Td).dxProgressBar({
            min: 0,
            max: parseInt(option.data.nb_dest_total),
            value: parseInt(option.data.nb_dest_envoye),
            width: "100%",
            showStatus: false
        }).dxProgressBar("instance");
        $TdStatut = $("<td style='width:1px;white-space:nowrap;padding-left:5px;'></td>").appendTo($Tr)
        Me.mUpdataData(option.data)
        container.css("height", "")
    }

    this.mUpdataData = function (dataCompteEmail) {
        option.data = dataCompteEmail
        progressBar.option({
            max: parseInt(option.data.nb_dest_total),
            value: parseInt(option.data.nb_dest_envoye)
        })
        if (option.data.nb_dest_total == null) {
            $TdStatut.html(option.data.nb_dest_envoye + "/0&bull;0%")
        } else {
            $TdStatut.html(option.data.nb_dest_envoye + "/" + option.data.nb_dest_total + "&bull;" + parseInt(option.data.nb_dest_envoye / option.data.nb_dest_total * 100) + "%")
        }
        $DivDetailStatut.html(option.data.statut_txt)
    }

    this.element = function () { return container }

    mConstruit();
}